import ChangePasswordWizard from "@/components/auth/ChangePassword/ChangePasswordWizard";
import RegenerateRecoveryKeyWizard from "@/components/auth/RegenerateRecoveryKey/RegenerateRecoveryKeyWizard";
import EmailChangeWizard from "./EmailChangeWizard";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { featureFlags } from "@/config/featureFlags";

interface ItemProps {
  children: ReactNode;
  title: string;
  description: string;
}
function Item({ children, title, description }: ItemProps) {
  return (
    <div className="flex flex-col items-start gap-2">
      <h5 className="text-sm font-normal">{title}</h5>
      <p className="text-sm font-light text-foreground/50">{description}</p>
      {children}
    </div>
  );
}

/**
 * The Security settings body (password / recovery key / email wizards).
 * Rendered by AccountTab (legacy accordion) and SettingsCategoryView (flag
 * `settingsMiddleViews`). Layout-neutral fragment: the host owns the wrapper
 * (`flex flex-col gap-8` + text-sm context) so the accordion DOM stays
 * byte-identical with the flag off.
 */
export default function SecurityContent() {
  const { t } = useTranslation();

  return (
    <>
      <Item
        title={t("recover.password")}
        description={t("securityMenu.passwordDescription")}
      >
        <ChangePasswordWizard />
      </Item>
      <span className="h-px bg-foreground/10"></span>
      <Item
        title={t("securityMenu.recoveryMethod")}
        description={t("securityMenu.recoveryDescription")}
      >
        <RegenerateRecoveryKeyWizard />
      </Item>
      {featureFlags.emailChange && (
        <>
          <span className="h-px bg-foreground/10"></span>
          <Item
            title={t("changeEmail.title")}
            description={t("changeEmail.description")}
          >
            <EmailChangeWizard />
          </Item>
        </>
      )}
    </>
  );
}
